import { HttpStatusCode } from 'axios'

export const isSuccessStatus = (status: number): boolean => {
  return status === HttpStatusCode.Ok || status === HttpStatusCode.Created
}

export const isOkStatus = (status: number): boolean => {
  return status === HttpStatusCode.Ok
}

export const isClientError = (status: number): boolean => {
  return status >= HttpStatusCode.BadRequest && status < HttpStatusCode.InternalServerError
}

export const isServerError = (status: number): boolean => {
  return status >= HttpStatusCode.InternalServerError
}
